import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EXCHANGE_RATES_SLICE_NAME } from './constants';
import {
	TAnnualExchangeRateListRequest,
	TAnnualExchangeRateListResponse,
	TDailyExchangeRateListRequest,
	TDailyExchangeRateListResponse,
	TExchangeRatesStore,
	TEuMonthlyExchangeRateListRequest,
	TEuMonthlyExchangeRateListResponse,
	TGbpMonthlyExchangeRateListRequest,
	TGbpMonthlyExchangeRateListResponse,
	TNonEuExchangeRateListRequest,
	TNonEuExchangeRateListResponse,
} from './types';

// ==========================================:
export const initialState: TExchangeRatesStore = {
	dailyList: null,
	dailyListLoading: false,
	dailyLastListParams: null,
	dailyRefreshLoading: false,

	annualList: null,
	annualListLoading: false,

	gbpMonthlyList: null,
	gbpMonthlyListLoading: false,

	euMonthlyList: null,
	euMonthlyListLoading: false,

	nonEuList: null,
	nonEuListLoading: false,
};

// ==========================================:
const exchangeRates = createSlice({
	name: EXCHANGE_RATES_SLICE_NAME,
	initialState,
	reducers: {
		getDailyExchangeRateListRequest: (
			state,
			action: PayloadAction<TDailyExchangeRateListRequest>,
		) => {
			state.dailyListLoading = true;
			state.dailyLastListParams = action.payload;
		},
		getDailyExchangeRateListSuccess: (
			state,
			action: PayloadAction<TDailyExchangeRateListResponse>,
		) => {
			state.dailyList = action.payload;
			state.dailyListLoading = false;
		},
		getDailyExchangeRateListFailure: (state) => {
			state.dailyListLoading = false;
		},

		refreshDailyExchangeRatesRequest: (state) => {
			state.dailyRefreshLoading = true;
		},
		refreshDailyExchangeRatesSuccess: (state) => {
			state.dailyRefreshLoading = false;
		},
		refreshDailyExchangeRatesFailure: (state) => {
			state.dailyRefreshLoading = false;
		},

		getAnnualExchangeRateListRequest: (
			state,
			_action: PayloadAction<TAnnualExchangeRateListRequest>,
		) => {
			state.annualListLoading = true;
		},
		getAnnualExchangeRateListSuccess: (
			state,
			action: PayloadAction<TAnnualExchangeRateListResponse>,
		) => {
			state.annualList = action.payload;
			state.annualListLoading = false;
		},
		getAnnualExchangeRateListFailure: (state) => {
			state.annualListLoading = false;
		},

		getGbpMonthlyExchangeRateListRequest: (
			state,
			_action: PayloadAction<TGbpMonthlyExchangeRateListRequest>,
		) => {
			state.gbpMonthlyListLoading = true;
		},
		getGbpMonthlyExchangeRateListSuccess: (
			state,
			action: PayloadAction<TGbpMonthlyExchangeRateListResponse>,
		) => {
			state.gbpMonthlyList = action.payload;
			state.gbpMonthlyListLoading = false;
		},
		getGbpMonthlyExchangeRateListFailure: (state) => {
			state.gbpMonthlyListLoading = false;
		},

		getEuMonthlyExchangeRateListRequest: (
			state,
			_action: PayloadAction<TEuMonthlyExchangeRateListRequest>,
		) => {
			state.euMonthlyListLoading = true;
		},
		getEuMonthlyExchangeRateListSuccess: (
			state,
			action: PayloadAction<TEuMonthlyExchangeRateListResponse>,
		) => {
			state.euMonthlyList = action.payload;
			state.euMonthlyListLoading = false;
		},
		getEuMonthlyExchangeRateListFailure: (state) => {
			state.euMonthlyListLoading = false;
		},

		getNonEuExchangeRateListRequest: (
			state,
			_action: PayloadAction<TNonEuExchangeRateListRequest>,
		) => {
			state.nonEuListLoading = true;
		},
		getNonEuExchangeRateListSuccess: (
			state,
			action: PayloadAction<TNonEuExchangeRateListResponse>,
		) => {
			state.nonEuList = action.payload;
			state.nonEuListLoading = false;
		},
		getNonEuExchangeRateListFailure: (state) => {
			state.nonEuListLoading = false;
		},

		exchangeRatesInitState: () => initialState,
	},
});

export default exchangeRates.reducer;
export const {
	getDailyExchangeRateListRequest,
	getDailyExchangeRateListSuccess,
	getDailyExchangeRateListFailure,
	refreshDailyExchangeRatesRequest,
	refreshDailyExchangeRatesSuccess,
	refreshDailyExchangeRatesFailure,
	getAnnualExchangeRateListRequest,
	getAnnualExchangeRateListSuccess,
	getAnnualExchangeRateListFailure,
	getGbpMonthlyExchangeRateListRequest,
	getGbpMonthlyExchangeRateListSuccess,
	getGbpMonthlyExchangeRateListFailure,
	getEuMonthlyExchangeRateListRequest,
	getEuMonthlyExchangeRateListSuccess,
	getEuMonthlyExchangeRateListFailure,
	getNonEuExchangeRateListRequest,
	getNonEuExchangeRateListSuccess,
	getNonEuExchangeRateListFailure,
	exchangeRatesInitState,
} = exchangeRates.actions;
